// extracted by mini-css-extract-plugin
export var screen1 = "screen1-module--screen1--ef138";
export var screen1__link = "screen1-module--screen1__link--287c5";
export var screen1__linkWrapper = "screen1-module--screen1__link-wrapper--8c402";
export var screen1__subtitle = "screen1-module--screen1__subtitle--3bbd6";
export var screen1__title = "screen1-module--screen1__title--90100";
export var screen1__titleWrapper = "screen1-module--screen1__title-wrapper--ef4ac";
export var screen1__wrapper = "screen1-module--screen1__wrapper--27831";